<template>
    <div class="roomDetail">
        <van-popup v-model="visible_com" round position="bottom" :style="{ height: '80%' }">
            <div :class="{ scrollPopupTitle: scrollPopup }" class="popupTitle flex-center width-100">
                <span v-show="scrollPopup">{{ title }}</span>
                <span class="flex-center" @click="visible_com = false">
                    <i class="fa fa-close" style="color: #fff;" />
                </span>
            </div>
            <div @scroll="handleScrollPopup" id="scrollPopup" class="scrollPopup width-100 height-100 scroll-y">
                <van-swipe
                    class="pop-swipe"
                    @change="e => (roomDetailIndicator = e)"
                    :autoplay="3000"
                    indicator-color="white"
                    :show-indicators="false"
                >
                    <van-swipe-item v-for="(item, index) in swipers" :key="index">
                        <div
                            id="popSwipeImg"
                            class="popSwipeImg bgi noImg"
                            :style="{
                                backgroundImage: `url('${$getImageUrl(item)}')`,
                            }"
                        ></div>
                    </van-swipe-item>
                </van-swipe>
                <div class="indicator">
                    <span>{{ roomDetailIndicator + 1 }}</span
                    >/<span>{{ swipers.length }}</span>
                </div>
                <div class="baseInfo">
                    <div>
                        {{ title }}
                    </div>
                    <div
                        class="facility-wrap jc-between flex-wrap"
                        :class="{ collapsedWrap: propertyCollapsed, spreadWrap: !propertyCollapsed }"
                        v-html="facilities.content"
                    >
                        <!-- <div @click="$toast(item.text)" class="facilityItem" v-for="(item, index) in facilities" :key="index">
                            <span>
                                <i :class="`c-darkgrey fa fa-fw ${item.icon}`" />
                            </span>
                            <span>{{ item.text }}</span>
                        </div>
                        <div class="facilityItem" v-for="item in facilities.length % 3" :key="item + 999"></div> -->
                    </div>
                    <div class="moreProperty flex-center" @click="propertyCollapsed = false" v-if="propertyCollapsed">
                        <span>更多房型设施</span>
                        <span v-if="true"><i class="fa fa-chevron-down"></i></span>
                    </div>
                    <div class="moreProperty flex-center" @click="propertyCollapsed = true" v-else>
                        <span>收起</span>
                        <span v-if="true"><i class="fa fa-chevron-up"></i></span>
                    </div>
                </div>
                <div class="notice-wrap">
                    <div>政策服务</div>
                    <div v-html="policy ? policy.content : ''"></div>
                </div>
                <slot name="buy" />
            </div>
        </van-popup>
        <!-- <ToTop v-if="visible_com" listId="scrollPopup"/> -->
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: "",
        },
        facilities: {
            type: Object,
            default: () => ({}),
        },
        properties: {
            type: Array,
            default: () => [],
        },
        mustRead: {
            type: Array,
            default: () => [],
        },
        notice: {
            type: String,
            default: "",
        },
        policy: {
            type: Object,
            default: () => ({}),
        },
        swipers: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            visible_com: false,
            propertyCollapsed: true,
            scrollPopup: false,
            roomDetailIndicator: 0,
        };
    },
    created() {},
    methods: {
        open() {
            this.propertyCollapsed = true;
            this.visible_com = true;
        },
        handleScrollPopup(e) {
            // document.getElementById("popSwipeImg").clientHeight
            this.scrollPopup = e.target.scrollTop >= 1;
        },
    },
};
</script>

<style lang="scss" scoped>
.roomDetail {
    /deep/.van-popup--bottom.van-popup--round {
        border-radius: 3.5vw 3.5vw 0 0;
    }
    .popupTitle {
        top: 0;
        height: 11vw;
        position: absolute;
        font-weight: bold;
        font-size: 4.1vw;
        background-color: transparent;
        z-index: 2;
        > span:last-child {
            font-size: 4vw;
            position: absolute;
            right: 5vw;
            top: 2vw;
            width: 6.5vw;
            height: 6.5vw;
            border-radius: 50%;
            background-color: rgba($color: #000000, $alpha: 0.5);
        }
    }
    .scrollPopupTitle {
        border-bottom: 1px solid #f3f3f3;
        background-color: #fff !important;
    }
    .scrollPopup {
        position: relative;
        $swipeHeight: 50vw;
        background-color: #f3f3f3;
        .pop-swipe {
            height: $swipeHeight;
            .popSwipeImg {
                height: $swipeHeight;
            }
        }
        .indicator {
            background-color: rgba($color: #000000, $alpha: 0.5);
            color: #fff;
            position: absolute;
            right: 4vw;
            top: calc(0.82 * #{$swipeHeight});
            border-radius: 4vw;
            padding: 0.5vw 2vw;
        }
        .baseInfo {
            padding: 3vw;
            background-color: #fff;
            > div:first-child {
                font-weight: bold;
                font-size: 4.5vw;
                margin-bottom: 4vw;
            }
            .facility-wrap {
                overflow: hidden;
                // margin-bottom: 2vw;
                .facilityItem {
                    display: flex;
                    align-items: center;
                    flex-wrap: nowrap;
                    width: 30%;
                    margin-bottom: 3vw;
                    > span:last-child {
                        font-size: 3.2vw;
                        margin-left: 1vw;
                        @extend .text-one;
                    }
                }
            }
            .spreadWrap {
                height: inherit;
                max-height: auto;
                transition: all 0.6s ease;
            }
            .collapsedWrap {
                height: 45vw;
                max-height: 45vw;
            }
            .property-wrap {
                overflow: hidden;
            }
            .moreProperty {
                margin-top: 2vw;
                color: rgb(35, 149, 255);
                > span:last-child {
                    margin-left: 1vw;
                    transform: translateY(-10%);
                }
            }
        }
        .notice-wrap {
            margin-top: 3vw;
            background-color: #fff;
            padding: 3vw;
            > div:first-child {
                font-weight: bold;
                font-size: 4.5vw;
                margin-bottom: 4vw;
            }
            > div:nth-child(2) {
                font-size: 3.2vw;
            }
        }
    }
}
</style>
